export const REFRESH_TOKEN = 'communicator-qa-refresh-token';
export const NYLAS_V3 = 'nylas-v3';
export const POLLING = 'communicator-polling-updates';
export const DEV_SETTINGS = 'communicator-dev-settings';
export const COMMUNICATOR_CALL_QUALITY_SURVEY =
  'communicator-call-quality-survey';
export const FORCE_POLLING = 'communicator-force-polling';
export const COMMUNICATOR_SIDEBAR_V2 = 'communicator-sidebar-v2';
export const COMMUNICATOR_CREATE_CONVERSATION_V2 =
  'communicator-create-conversation-v2';
export const COMMUNICATOR_ENFORCE_PCMU_CODEC =
  'communicator-enforce-pcmu-codec';
export const COMMUNICATOR_REACTIONS = 'communicator-reactions';
export const COMMUNICATOR_SOFTPHONE_V2 = 'communicator-softphone-v2';
export const COMMUNICATOR_SOFTPHONE_DIAGNOSTICS =
  'communicator-softphone-diagnostics';
export const COMMUNICATOR_ADVANCED_SETTINGS = 'communicator-advanced-settings';
export const COMMUNICATOR_MARK_AS_UNREAD = 'communicator-mark-as-unread';
export const COMMUNICATOR_GIFS = 'communicator-gifs';
export const COMMUNICATOR_VIDEO_TRANSCRIPTION = 'communicator-video-transcription';
export const COMMUNICATOR_VIDEO_SUMMARY = 'communicator-video-summary';
export const CALL_LOGS_DELETION = 'call-logs-deletion';
export const COMMUNICATOR_HIDE_CHAT_CALL_HISTORY =
  'communicator-hide-chat-call-history';